import { post, get } from './FetchAdapter'
import {
    API_URL,
    APP_NAME,
    CONTENT_SERVICE_API,
    getPlatformForApi,
} from '../configs/main'
import { ENV } from '../configs/env'

export const getLiveCasinoGamesAdapter = (
    category = '',
    pageNumber = 1,
    providers = []
) => {
    return get(API_URL + 'categories/liveint/games', {
        platform: getPlatformForApi(),
        srv: ENV(),
        app: APP_NAME,
        'page[size]': 20,
        'page[number]': pageNumber,
        sort_clicks: true,
        ...(category && { subcat: category }),
    })
        .then((res) => {
            const responseData = res.data || []

            let games = responseData.filter((g) => g.rod_hide === false)

            if (providers.length > 0) {
                games = games.filter(
                    (game) => game.provider && providers.includes(game.provider)
                )
            }

            return {
                meta: res.meta || { total: 0, last_page: 1 },
                games,
                gameIds: games.reduce((acc, game) => {
                    if (game.table_id) {
                        acc.push(game.table_id)
                    }
                    return acc
                }, []),
            }
        })
        .catch((error) => {
            console.error('Error fetching live casino games:', error)
            // Return empty data structure with defaults in case of error
            return {
                meta: { total: 0, last_page: 1 },
                games: [],
                gameIds: [],
            }
        })
}

export const getLiveCasinoProvidersData = (gamesIDs) => {
    if (!gamesIDs || !gamesIDs.length) {
        return Promise.resolve([])
    }

    return post(CONTENT_SERVICE_API + 'live/gamesListInfo', gamesIDs)
        .then((gamesInfo) => {
            return gamesInfo.data
        })
        .catch((err) => {
            console.error('Error fetching live casino providers data:', err)
            return []
        })
}

// Helper function to update games with provider data
export const updateGamesWithProviderData = (games, providerData) => {
    return games.map((game) => ({
        ...game,
        liveCas:
            providerData.find(
                (info) => info && info.tableId === game.table_id
            ) || {},
    }))
}

// New function to handle periodic updates
export const createProviderDataUpdater = (
    gameIds,
    onUpdate,
    interval = 30000
) => {
    if (!gameIds || !gameIds.length) {
        return {
            start: () => {},
            stop: () => {},
        }
    }

    let intervalId = null

    const update = async () => {
        try {
            const data = await getLiveCasinoProvidersData(gameIds)
            onUpdate(data)
        } catch (error) {
            console.error('Failed to update provider data:', error)
        }
    }

    return {
        start: () => {
            // Initial update
            update()
            // Set up interval
            intervalId = setInterval(update, interval)
        },
        stop: () => {
            if (intervalId) {
                clearInterval(intervalId)
                intervalId = null
            }
        },
    }
}

export default {
    getLiveCasinoGamesAdapter,
    getLiveCasinoProvidersData,
    updateGamesWithProviderData,
    createProviderDataUpdater,
}
